<template>
  <div class="data-list">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div class="list-item" v-for="(item, index) in list" :key="index">
        <slot name="item" v-bind:obj="item"> </slot>
      </div>
    </van-list>
  </div>
</template>

<script>
import { List } from "vant";

export default {
  name: "DoctorList",
  components: {
    [List.name]: List,
  },
  props: {
    api: {
      type: String,
      default: "",
    },
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    onAutoLoad: {
      type: Boolean,
      default: false,
    },

    params: {
      type: Object,
      default() {
        return {};
      },
    },
    onLoadCallBack: { type: Function },
  },

  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      error: false,
      tabActive: 0,
      PageIndex: 0,
    };
  },
  watch: {
    params() {
      this.list = [];
      this.PageIndex = 0;
      // this.loading = true;
      this.finished = false;
    },
    data() {
      this.onLoad();
    },
  },
  created() {
    if (this.onAutoLoad) {
      this.loading = false;
      this.finished = true;
    }
  },
  methods: {
    onLoad() {
      const that = this;
      // this.onLoad = true;
      // setTimeout(() => {
      const base = {
        PageIndex: this.PageIndex,
        PageSize: 20,
      };
      const json = { ...base, ...this.params };
      if (this.api) {
        this.$post(this.api, json)
          .then(res => {
            let data = res.data.datas;
            if (this.onLoadCallBack) {
              const callbackRes = this.onLoadCallBack(res);
              if (callbackRes) {
                data = callbackRes;
              }
            }
            this.PageIndex = json.PageIndex + 1;
            this.list = this.list.concat(data);
            this.loading = false;
            if (this.list.length >= res.data.total) {
              this.finished = true;
            }
          })
          .catch(() => {
            this.loading = false;
            this.error = true;
          });
      } else if (this.data && this.data.length) {
        that.list = [];
        that.list = this.data;
        that.loading = false;
        that.finished = true;
        // setTimeout(() => {
        //   that.list = this.data;
        //   that.loading = false;
        //   that.finished = true;
        // }, 1000);
      } else {
        that.list = [];
        that.loading = false;
        that.finished = true;
        // setTimeout(() => {
        //   that.loading = false;
        //   that.finished = true;
        // }, 1000);
      }
      // }, 500);
    },
    reload() {
      this.list = [];
      this.PageIndex = 0;
      this.finished = false;
    },
  },
};
</script>

<style lang="less" scoped>
.data-list {
  font-size: 0.35rem;
}
</style>
